import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useJobsPosition() {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)

  const refetch = (divisi_id?: string) => {
    setLoading(true)

    api.get(
      "/jobposition/",
      { params: { divisi_id } }
    )
    .then((res: SuccessFetch<{
      payload: {
        job_position_id: number
        job_position_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.job_position_name, value: item.job_position_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    setLoading(true)
    
    api.get("/jobposition/")
    .then((res: SuccessFetch<{
      payload: {
        job_position_id: number
        job_position_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.job_position_name, value: item.job_position_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
    // eslint-disable-next-line
  }, [])

  return { data, isLoading, refetch }
}